import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { GiPsychicWaves } from "react-icons/gi";

const fortunes = [
    "확고한 결정을 내리는 날!!! 아니면 그럴까요?", 
    "광기가 다시 시작되기 몇 시간 전의 은혜", 
    "곧 꽃 선물이 당신에게 주어질 것입니다.", 
    "오래 잊혀진 사랑하는 사람이 곧 나타날 것입니다. 어떤 대가를 치르더라도 부정적인 것들을 사세요.", 
    "키 크고 어두운 낯선 사람이 당신보다 더 재미있을 것입니다.", 
    "새로운 곳을 방문하면 이상한 일이 생길 것입니다.", 
    "낯선 곳을 방문하면 신선한 일이 생길 것입니다.", 
    "생생하고 창의적인 마음이 당신을 특징짓습니다.",
    "진실 찾기를 포기하세요; 좋은 환상에 만족하세요.", 
    "당신의 본성에 도움이 되는 쪽으로 향합니다. 해자를 빼세요.", 
    "진격", 
    "연인이 떠난 후에도 당신은 여전히 땅콩버터를 가질 것입니다!", 
    "오후에는 로맨스에 매우 유리합니다. 변화를 위해 한 사람을 시도하세요.", 
    "위조금과 뇌물은 당신의 재산의 많은 부분을 차지할 것입니다.", 
    "모든 문제는 매우 빨리 사라질 것입니다.", 
    "운이 좋은 사람들 중에서 당신은 선택된 사람입니다.",
    "아보카도 톤의 냉장고가 이력서에 잘 어울릴 것 같아요."
];

const FortuneCookie = () => {
    const [isRevealed, setIsRevealed] = useState(false);
    const [isShaking, setIsShaking] = useState(false);
    const [randomImg, setRandomImg] = useState(Math.floor(Math.random() * 4) + 1);
    const [randomFortune, setRandomFortune] = useState(fortunes[Math.floor(Math.random() * fortunes.length)]);

    const handleCookieClick = (e) => {
        e.stopPropagation(); // 이벤트 전파 막기
        if (isRevealed || isShaking) return;

        setIsShaking(true);
        setTimeout(() => {
            setIsShaking(false);
            setIsRevealed(true);
        }, 500); // 0.5초 동안 진동 흔들림 효과
    };

    const handleReset = () => {
        setIsRevealed(false);
        setIsShaking(false);
        setRandomImg(Math.floor(Math.random() * 4) + 1);
        setRandomFortune(fortunes[Math.floor(Math.random() * fortunes.length)]);
    };

    return (
        <div className="saju-wrapper">
            <Container>
                <div className="saju-card-container text-center">
                    <h2 className="mb-3 d-flex align-items-center justify-content-center gap-2 fw-bold text-warning">
                        <GiPsychicWaves /> 포춘 쿠키
                    </h2>
                    <p className="text-muted small">
                        포춘쿠키를 터치하면 바삭하게 쪼개지며 하루의 숨겨진 행운 메시지가 나타납니다.
                    </p>

                    <div className="cookie-stage">
                        {/* 포춘쿠키 이미지 컨테이너 */}
                        <div
                            className={`cookie-box ${isRevealed ? "revealed" : ""} ${isShaking ? "shake" : ""}`}
                            onClick={handleCookieClick} // 클릭 시 이벤트 처리
                        >
                            {/* 왼쪽 반쪽 */}
                            <img
                                src={`${process.env.PUBLIC_URL}/fortuneCookie${randomImg}.jpg`}
                                alt="포춘쿠키 왼쪽"
                                className="cookie-slice cookie-slice-left"
                            />
                            {/* 오른쪽 반쪽 */}
                            <img
                                src={`${process.env.PUBLIC_URL}/fortuneCookie${randomImg}.jpg`}
                                alt="포춘쿠키 오른쪽"
                                className="cookie-slice cookie-slice-right"
                            />

                            {/* 흐리게 처리된 초기 텍스트 가이드 */}
                            {!isRevealed && !isShaking && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: '-25px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '100%',
                                    fontWeight: '700',
                                    color: '#a0aec0',
                                    fontSize: '0.88rem',
                                    letterSpacing: '0.05em'
                                }}>
                                    쿠키를 터치하세요!
                                </div>
                            )}

                            {isShaking && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: '-25px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '100%',
                                    fontWeight: '700',
                                    color: '#d69e2e',
                                    fontSize: '0.88rem',
                                    letterSpacing: '0.05em'
                                }}>
                                    쿠키 쪼개는 중...
                                </div>
                            )}
                        </div>

                        {/* 쪼개졌을 때 나타나는 쪽지 */}
                        <div className={`fortune-paper-slip ${isRevealed ? "revealed" : ""}`}>
                            <div className="fortune-paper-title">행운의 쪽지</div>
                            <div className="fortune-paper-text">“{randomFortune}”</div>
                        </div>
                    </div>

                    {/* 리셋 버튼 */}
                    {isRevealed && (
                        <div className="mt-4">
                            <Button className="fortune-reset-btn" onClick={handleReset}>
                                쿠키 새로 굽기 (다시 뽑기)
                            </Button>
                        </div>
                    )}
                </div>
            </Container>
        </div>
    );
};

export { FortuneCookie };
